import {GET_LANGUAGE} from '../types/Type'


export const languageReducer = (state, action) => {
    switch(action.type){
        case GET_LANGUAGE:
            return {...state, language: action.payload.language}
        default:
        return state
    }

}